import React from 'react';
import styles from './GebiedsanalyseModule.module.css';
import { VoorzieningenData, VoorzieningItem } from '../../types';
import { VOORZIENING_ICON_MAP, SportIcon, PinIcon } from './CategoryIcons';

const CATEGORY_LABELS: Record<string, string> = {
  huisarts: 'Huisarts',
  ziekenhuis: 'Ziekenhuis',
  apotheek: 'Apotheek',
  supermarkt: 'Supermarkt',
  basisschool: 'Basisschool',
  middelbare_school: 'Middelbare school',
  sportvoorziening: 'Sportvoorziening',
  ov_halte: 'Openbaar vervoer',
  gemeentehuis: 'Gemeentehuis',
};

const CATEGORY_ICON_LOOKUP: Record<string, React.FC<{ size?: number; color?: string }>> = {
  ...VOORZIENING_ICON_MAP,
  sportvoorziening: SportIcon,
};

interface VoorzieningenSectionProps {
  data: VoorzieningenData | null;
  onItemClick?: (lat: number, lon: number) => void;
}

export default function VoorzieningenSection({ data, onItemClick }: VoorzieningenSectionProps) {
  if (!data || data.stats.length === 0) return null;

  return (
    <div className={styles.section}>
      <h3>Voorzieningen (binnen {data.searchRadius / 1000} km)</h3>
      <div className={styles.facilityList}>
        {data.stats.map((stat) => {
          const label = CATEGORY_LABELS[stat.category] || stat.category;
          const IconComp = CATEGORY_ICON_LOOKUP[stat.category] || PinIcon;
          return (
            <div key={stat.category} className={styles.facilityItem}>
              <span>
                <span className={styles.categoryIcon}><IconComp size={14} color="#9DA6A8" /></span>{' '}
                {label}
              </span>
              <span>{stat.count}x — {stat.nearestDistance} km</span>
            </div>
          );
        })}
      </div>

      {data.items.length > 0 && (
        <div className={styles.topSectorenList} style={{ marginTop: 14 }}>
          <h4 style={{
            fontFamily: "'Open Sans', sans-serif",
            fontSize: 12,
            fontWeight: 600,
            color: '#9DA6A8',
            textTransform: 'uppercase',
            margin: '0 0 6px',
            letterSpacing: '0.5px'
          }}>Dichtstbijzijnde voorzieningen</h4>
          {getClosestPerCategory(data.items).map((item) => {
            const IconComp = CATEGORY_ICON_LOOKUP[item.category] || PinIcon;
            return (
              <button
                key={item.osmId}
                className={styles.omgevingsListItem}
                onClick={() => onItemClick?.(item.lat, item.lon)}
                title={`${item.name} — ${item.distance} km`}
              >
                <span className={styles.categoryIcon}><IconComp size={14} color="#9DA6A8" /></span>
                <span className={styles.omgevingsListContent}>
                  <span className={styles.omgevingsListTitle}>{item.name}</span>
                  <span className={styles.omgevingsListMeta}>{item.subcategory} — {item.distance} km</span>
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

function getClosestPerCategory(items: VoorzieningItem[]): VoorzieningItem[] {
  const seen = new Set<string>();
  const result: VoorzieningItem[] = [];
  for (const item of items) {
    if (!seen.has(item.category)) {
      seen.add(item.category);
      result.push(item);
    }
  }
  return result;
}
